import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type DealerCsvImportInsertBatchJobsMutationVariables = Types.Exact<{
  jobs: Array<Types.Batch_Jobs_Insert_Input> | Types.Batch_Jobs_Insert_Input;
}>;


export type DealerCsvImportInsertBatchJobsMutation = { __typename?: 'mutation_root', insert_batch_jobs?: { __typename?: 'batch_jobs_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'batch_jobs', id: number, batch_id: string, input?: object | null, sequence?: number | null, status: string, trigger_type?: string | null, createdat?: string | null, createdby?: string | null }> } | null };


export const DealerCsvImportInsertBatchJobsDocument = gql`
    mutation dealerCsvImportInsertBatchJobs($jobs: [batch_jobs_insert_input!]!) {
  insert_batch_jobs(objects: $jobs) {
    affected_rows
    returning {
      id
      batch_id
      input
      sequence
      status
      trigger_type
      createdat
      createdby
    }
  }
}
    `;
export type DealerCsvImportInsertBatchJobsMutationFn = Apollo.MutationFunction<DealerCsvImportInsertBatchJobsMutation, DealerCsvImportInsertBatchJobsMutationVariables>;

/**
 * __useDealerCsvImportInsertBatchJobsMutation__
 *
 * To run a mutation, you first call `useDealerCsvImportInsertBatchJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealerCsvImportInsertBatchJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealerCsvImportInsertBatchJobsMutation, { data, loading, error }] = useDealerCsvImportInsertBatchJobsMutation({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */
export function useDealerCsvImportInsertBatchJobsMutation(baseOptions?: Apollo.MutationHookOptions<DealerCsvImportInsertBatchJobsMutation, DealerCsvImportInsertBatchJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealerCsvImportInsertBatchJobsMutation, DealerCsvImportInsertBatchJobsMutationVariables>(DealerCsvImportInsertBatchJobsDocument, options);
      }
export type DealerCsvImportInsertBatchJobsMutationHookResult = ReturnType<typeof useDealerCsvImportInsertBatchJobsMutation>;
export type DealerCsvImportInsertBatchJobsMutationResult = Apollo.MutationResult<DealerCsvImportInsertBatchJobsMutation>;
export type DealerCsvImportInsertBatchJobsMutationOptions = Apollo.BaseMutationOptions<DealerCsvImportInsertBatchJobsMutation, DealerCsvImportInsertBatchJobsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moveImport/gql/insertBatchJobs.mutation.gql}
 */
export async function dealerCsvImportInsertBatchJobs(
  variables: DealerCsvImportInsertBatchJobsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DealerCsvImportInsertBatchJobsMutation['insert_batch_jobs']>
export async function dealerCsvImportInsertBatchJobs(
  variables: DealerCsvImportInsertBatchJobsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DealerCsvImportInsertBatchJobsMutation>
export async function dealerCsvImportInsertBatchJobs(
  variables: DealerCsvImportInsertBatchJobsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DealerCsvImportInsertBatchJobsMutation['insert_batch_jobs'] | DealerCsvImportInsertBatchJobsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DealerCsvImportInsertBatchJobsMutation>(
    DealerCsvImportInsertBatchJobsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_batch_jobs
}